import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { format } from 'date-fns';

@Component({
  selector: 'app-date-label',
  standalone: true,
  imports: [],
  templateUrl: './date-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateLabelComponent {
  matchDate = input.required<Date>();

  handleDate = computed(() => {
    const fommated = 'yyyy-MM-dd';

    return format(this.matchDate(), fommated);
  });
}
